export default __webpack_public_path__ + "static/media/banner-bg-xl.4f75f9be.svg";